<template>
  <div class="star">
    <span class="star-item" v-for="(i, index) in starList" :key="index" :class="i" @click="rateNum(index)"></span>
  </div>
</template>
<script>

export default {
  data() {
    return {
        starList: [
            'off',
            'off',
            'off',
            'off',
            'off',
        ]
     }
  },
  props: {
      start: {
        type: Object,
        default: () => {}
      }
  },
  methods: {
      rateNum(index) {
          console.log(index)
             this.starList.forEach((item, num) => {
              if (num < index + 1) {
                 this.starList[num] = 'on'
                 console.log(item)
              } else {
                 this.starList[num] = 'off'
              }
          })
          console.log(this.starList)
          this.$forceUpdate()
          this.start.starts = index + 1
          this.$emit('start', this.start)
      },
      reset() {
        this.starList.map(item => {
          item = 'off'
        })
      },
  },
}
</script>
<style lang="less" scoped>
.star{
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
}
.star-item {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin-right: 8px;
  background-size: 20px 20px;
  &.off {
    background-image: url('../../assets/icons/星星 灰@3x.png');
  }
  &.on {
    background-image: url('../../assets/icons/星星 黄@3x.png');
  }
}
</style>
